// const API = "http://localhost:8000";

const API = "https://salluuu-pets-server.onrender.com"

export default API;